import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28b238bf"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=28b238bf&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b238bf')) {
      api.createRecord('28b238bf', component.options)
    } else {
      api.reload('28b238bf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28b238bf", function () {
      api.rerender('28b238bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/centricOS-global-menu-group-permissions/index.vue"
export default component.exports